import request from "./request";

const TicketDashboardService = {
    GetCourses: async (context, signal) => {
        return await request.sendRequest(`/ticket/courses/all`, context.token, signal);
    },
    GetDashboard: async (context, signal) => {
        return await request.sendRequest(`/ticket/dashboard`, context.token, signal);
    },
    GetUserDashboard: async (context, signal) => {
        return await request.sendRequest(`/ticket/dashboard/users`, context.token, signal);
    },
    GetTicketDashboard: async (id, context, signal) => {
        return await request.sendRequest(`/ticket/dashboard/tickets/${id}`, context.token, signal);
    },
    GetTicketCategoryWiseDashboard: async (context, signal) => {
        return await request.sendRequest(`/ticket/dashboard/category`, context.token, signal);
    },
    GetRecentTicketsDashboard: async (context, signal) => {
        return await request.sendRequest(`/ticket/dashboard/recents`, context.token, signal);
    },
};

export default TicketDashboardService;
